module.exports = __webpack_public_path__ + "static/5-44b4bbce64c492040f6d3e56eac1ae1a.jpg";